// extracted by mini-css-extract-plugin
module.exports = {"theme":"#e6ab0d"};